import { Dispatch, SetStateAction, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import TableSearch from './TableSearch';

type SearchTableProps = {
    search: string;
    setSearch: Dispatch<SetStateAction<string>>;
    setPage: Dispatch<SetStateAction<number>>;
    disabled?: boolean;
    inputDisabled?: boolean;
    buttonDisabled?: boolean;
    placeholder?: string;
    onSearchEvent?: () => void;
};

const SearchTable = ({ search, setSearch, setPage, onSearchEvent, ...props }: SearchTableProps) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [value, setValue] = useState('');
    return <TableSearch {...props} value={value} appliedSearch={search} onChange={setValue} onSearch={nextSearch => {
        const searchParams = new URLSearchParams(location.search);
        searchParams.delete('PageNo');
        navigate({ pathname: location.pathname, search: searchParams.toString() });
        setPage(0);
        setSearch(nextSearch);
        onSearchEvent?.();
    }} />;
};

export default SearchTable;
